module.exports = __webpack_public_path__ + "static/45-d5fc72e9dab04865ee30c90598faab09.png";